import { SET_FULLTEXT_THEMEN, SET_FULLTEXT_REFERENTEN, SET_EINSATZGEBIET, RESET } from '../../types/themenFilters'

const initialState = {
    themen: null,
    referenten: null,
    einzugsgebiet: null
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_FULLTEXT_THEMEN:
            return Object.assign({}, state, {
                themen: action.data
            })
        case SET_FULLTEXT_REFERENTEN:
            return Object.assign({}, state, {
                referenten: action.data
            })
        case SET_EINSATZGEBIET:
            return Object.assign({}, state, {
                einsatzgebiet: action.data
            })
        case RESET:
            return Object.assign({}, state, {
                themen: null,
                referenten: null,
                einzugsgebiet: null
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/referenten/filters.js